import { ReactElement } from 'react';
import { useViewProvider } from '../../../modules/contexts/view-provider-context/ViewProvider';
import { CancelConfirmationModalContentViewProps } from './CancelConfirmationModalContentViewProps';

export function CancelConfirmationModalContent(viewProps: CancelConfirmationModalContentViewProps): ReactElement {
  const viewProvider = useViewProvider();

  return viewProvider.renderCancelConfirmationModalContent(viewProps);
}
